// Verify against the MCS download before printing these on a customer document.

export const POSTCODE_ZONES: Record<string, string> = {
  AB: '16',
  AL: '1',
  B: '6',
  BA: '5E',
  BB: '7E',
  BD: '11',
  BH: '3',
  BL: '7E',
  BN: '2',
  BR: '2',
  BS: '5E',
  BT: '21',
  CA: '8E',
  CB: '12',
  CF: '5W',
  CH: '7E',
  CM: '12',
  CO: '12',
  CR: '1',
  CT: '2',
  CV: '6',
  CW: '7E',
  DA: '2',
  DD: '15',
  DE: '6',
  DG: '8S',
  DH: '10',
  DL: '10',
  DN: '11',
  DT: '3',
  DY: '6',
  E: '1',
  EC: '1',
  EH: '15',
  EN: '1',
  EX: '4',
  FK: '14',
  FY: '7E',
  G: '14',
  GL: '5E',
  GU: '1',
  HA: '1',
  HD: '11',
  HG: '10',
  HP: '1',
  HR: '6',
  HS: '18',
  HU: '11',
  HX: '11',
  IG: '12',
  IP: '12',
  IV: '17',
  KA: '14',
  KT: '1',
  KW: '17',
  KY: '15',
  L: '7E',
  LA: '7E',
  LD: '13',
  LE: '6',
  LL: '7W',
  LN: '11',
  LS: '11',
  LU: '1',
  M: '7E',
  ME: '2',
  MK: '1',
  ML: '14',
  N: '1',
  NE: '9E',
  NG: '11',
  NN: '6',
  NP: '5W',
  NR: '12',
  NW: '1',
  OL: '7E',
  OX: '1',
  PA: '14',
  PE: '12',
  PH: '15',
  PL: '4',
  PO: '3',
  PR: '7E',
  RG: '1',
  RH: '1',
  RM: '12',
  S: '11',
  SA: '5W',
  SE: '1',
  SG: '1',
  SK: '7E',
  SL: '1',
  SM: '1',
  SN: '5E',
  SO: '3',
  SP: '5E',
  SR: '9E',
  SS: '12',
  ST: '6',
  SW: '1',
  SY: '6',
  TA: '5E',
  TD: '9S',
  TF: '6',
  TN: '2',
  TQ: '4',
  TR: '4',
  TS: '10',
  TW: '1',
  UB: '1',
  W: '1',
  WA: '7E',
  WC: '1',
  WD: '1',
  WF: '11',
  WN: '7E',
  WR: '6',
  WS: '6',
  WV: '6',
  YO: '10',
  ZE: '20',
};

// [startDistrict, endDistrict, zoneId] ranges; overrides POSTCODE_ZONES for districts in range.
export const POSTCODE_OVERRIDES: Record<string, [number, number, string][]> = {
  BD: [[23, 24, '10']],
  CH: [[5, 8, '7W']],
  CM: [[21, 23, '1']],
  DH: [[4, 5, '9E']],
  EH: [[43, 46, '9S']],
  EN: [[9, 9, '12']],
  GU: [
    [11, 12, '3'],
    [14, 14, '3'],
    [28, 29, '2'],
    [30, 35, '3'],
    [46, 46, '3'],
    [51, 52, '3'],
  ],
  IV: [
    [30, 32, '16'],
    [36, 36, '16'],
  ],
  KW: [[15, 17, '19']],
  LA: [[7, 23, '8E']],
  LL: [
    [23, 27, '13'],
    [30, 78, '13'],
  ],
  LS: [[24, 24, '10']],
  NP: [[8, 8, '13']],
  PE: [
    [9, 12, '11'],
    [20, 25, '11'],
  ],
  PH: [
    [19, 25, '17'],
    [26, 26, '16'],
    [30, 44, '17'],
    [49, 49, '14'],
    [50, 50, '14'],
  ],
  PO: [[18, 22, '2']],
  RG: [[21, 29, '3']],
  RH: [[1, 20, '2']],
  S: [
    [18, 18, '6'],
    [32, 33, '6'],
    [40, 45, '6'],
    [49, 49, '6'],
  ],
  SA: [
    [14, 20, '13'],
    [31, 48, '13'],
    [61, 73, '13'],
  ],
  SK: [
    [13, 13, '6'],
    [17, 17, '6'],
    [22, 23, '6'],
  ],
  SN: [[7, 7, '1']],
  SP: [[6, 11, '3']],
  SR: [[7, 8, '10']],
  SY: [
    [14, 14, '7E'],
    [15, 25, '13'],
  ],
  TD: [
    [12, 12, '9E'],
    [15, 15, '9E'],
  ],
  YO: [
    [15, 16, '11'],
    [25, 25, '11'],
  ],
};

export const ZONE_NAMES: Record<string, string> = {
  '1': 'London',
  '2': 'Brighton',
  '3': 'Southampton',
  '4': 'Plymouth',
  '5E': 'Bristol',
  '5W': 'Cardiff',
  '6': 'Birmingham',
  '7E': 'Manchester',
  '7W': 'Chester',
  '8S': 'Dumfries',
  '8E': 'Carlisle',
  '9E': 'Newcastle',
  '9S': 'Edinburgh',
  '10': 'Middlesbrough',
  '11': 'Sheffield',
  '12': 'Norwich',
  '13': 'Aberystwyth',
  '14': 'Glasgow',
  '15': 'Dundee',
  '16': 'Aberdeen',
  '17': 'Inverness',
  '18': 'Stornoway',
  '19': 'Kirkwall',
  '20': 'Lerwick',
  '21': 'Belfast',
};
